import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

// Same centered 720px column as the Sweep Account page (core/components/sweep-account), the other
// account-menu destination, so the two read as one family.
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    margin: '0 auto',
    position: 'relative',
    padding: theme.spacing(8, 0)
  },
  title: {
    justifyContent: 'center',
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    justifyContent: 'center',
    marginBottom: theme.spacing(6)
  },
  search: {
    marginBottom: theme.spacing(6)
  },
  listTitle: {
    marginBottom: theme.spacing(2)
  },
  list: {
    background: theme.colorPalette.beige_25,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(0, 6)
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(4, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  rowText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  empty: {
    justifyContent: 'center',
    padding: theme.spacing(6, 0)
  },
  error: {
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    color: theme.colors.error
  }
}));

export default useStyles;
